module.exports = __webpack_public_path__ + "img/short01.4073ca95.jpg";